import { useQuery } from '@tanstack/react-query';

import { type Balance, balanceQueries } from '@/api';

import { useSession } from './use-session';

/**
 * Баланс дилера. Запит вмикається лише для автентифікованого: гостю
 * бекенд відповів би 401, і це виглядало б як збій, а не як «немає акаунта».
 */
export function useBalance(): { balance: Balance | null; isPending: boolean } {
	const { isAuthenticated } = useSession();
	const { data, isPending } = useQuery({ ...balanceQueries.current(), enabled: isAuthenticated });
	return { balance: data ?? null, isPending: isAuthenticated && isPending };
}
